import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReportHtml } from 'tms-lib';
import { TmsWebBaseService } from '../base';
import { PurchaseOrderReport } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderReportsService extends TmsWebBaseService {
  constructor() {
    super('PurchaseOrderReports');
  }

  getPurchaseOrder(id: string, pickingList: boolean): Observable<PurchaseOrderReport> {
    return this.httpService.get<PurchaseOrderReport>(
      `${this.apiUrl}/PurchaseOrder?id=${id}&pickingList=${pickingList}`,
    );
  }

  getPurchaseOrderReportHtml(id: string, includeStyles: boolean): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/PurchaseOrderReportHtml?id=${id}&includeStyles=${includeStyles}`)
      .pipe(map((model: ReportHtml) => model.html));
  }

  getPickingListHtml(id: string, includeStyles: boolean): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/PickingListHtml?id=${id}&includeStyles=${includeStyles}`)
      .pipe(map((model: ReportHtml) => model.html));
  }

  getSupplierDocumentHtml(id: string): Observable<string[]> {
    return this.httpService
      .get<ReportHtml[]>(`${this.apiUrl}/SupplierDocumentHtml?id=${id}`)
      .pipe(map((models: ReportHtml[]) => models.map((model: ReportHtml) => model.html)));
  }
}
